<sp-color-picker-v2
    [color]="color"
    [ariaLabel]="ariaLabel"
    [positionLeft]="positionLeft"
    [hideGradient]="hideGradient"
    [colorsPreset]="selectedThemeColors()"
    (colorChangeEvent)="colorChangeEvent.emit($event)"
/>
